class WriterPortalLogin extends HTMLElement {
  constructor() {
    super();
    this.supabaseUrl = this.dataset.supabaseUrl;
    this.anonKey = this.dataset.supabaseAnonKey;
    this.dashboardUrl = this.dataset.dashboardUrl || '/';

    this.form = this.querySelector('.writer-portal-login__form');
    this.successMessage = this.querySelector('.writer-portal-login__success');
    this.submitBtn = this.form.querySelector('button[type="submit"]');

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();
    const email = new FormData(this.form).get('email');
    if (!email) return;

    this.submitBtn.disabled = true;

    try {
      await fetch(`${this.supabaseUrl}/functions/v1/writer-request-login`, {
        method: 'POST',
        headers: { apikey: this.anonKey, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          redirect_to: new URL(this.dashboardUrl, window.location.origin).href,
        }),
      });
    } catch (error) {
      // Same message either way - see writer-request-login for why.
    }

    this.form.hidden = true;
    this.successMessage.hidden = false;
    this.submitBtn.disabled = false;
  }
}

customElements.define('writer-portal-login', WriterPortalLogin);
